import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store/types";

// Root selectors
const getStopContactState = (state: RootState) => state.stopContact;

export const getStopContactDataSelector = createSelector(
  [getStopContactState],
  (stopContact) => stopContact?.stopContactData,
);

export const getStopContactPendingSelector = createSelector(
  [getStopContactState],
  (stopContact) => stopContact?.isSCPending,
);

export const getStopContactErrorSelector = createSelector(
  [getStopContactState],
  (stopContact) => stopContact?.isSCError,
);

export const getStopContactDeleteSelector = createSelector(
  [getStopContactState],
  (stopContact) => stopContact?.isSCDelete,
);

export const getStopContactStatusSelector = createSelector(
  [getStopContactState],
  (stopContact) => stopContact?.status,
);
